import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useKeenSlider } from "keen-slider/react";
import bus from '../images/yellow-bus.png';
import enBus from '../images/yellow-bus-en.png';
import abdobus from '../images/bus.png';
import forgiens from '../images/forgiens.png';
import bags from '../images/bags.jpg';
import haj from '../images/haj.png';
import pass from '../images/passengers.jpg';
import drivers from '../images/drivers.jpeg';
import right from '../images/right.png';
import left from '../images/left.png';
import "keen-slider/keen-slider.min.css";

export default function Home() {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const timerRef = useRef(null);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider({
        loop: true,
        rtl: isRTL,
        slides: {
            perView: 3,
            spacing: 15,
        },
        breakpoints: {
            "(max-width: 768px)": {
                slides: { perView: 1 },
            },
            "(min-width: 769px) and (max-width: 1024px)": {
                slides: { perView: 2 },
            },
        },
        created() {
            setLoaded(true); // يمنع الخطأ عند أول تحميل
        },
    });

    // Auto Slide
    useEffect(() => {
        if (!loaded) return;
        const interval = setInterval(() => {
            instanceRef.current?.next();
        }, 3000);
        timerRef.current = interval;
        return () => clearInterval(timerRef.current);
    }, [instanceRef, loaded]);

    // Force update when images might not load immediately
    useEffect(() => {
        const timeout = setTimeout(() => {
            instanceRef.current?.update();
        }, 800);
        return () => clearTimeout(timeout);
    }, []);

    const services = [
        { id: 1, title: t('passengerTransport'), image: pass },
        { id: 2, title: t('vipService'), image: forgiens },
        { id: 3, title: t('cargoTransport'), image: bags },
        { id: 4, title: t('hajService'), image: haj },
        { id: 5, title: t('modernFleet'), image: abdobus },
        { id: 6, title: t('experiencedDrivers'), image: drivers },
    ];

    return (
        <div className="flex flex-col bg-transparent">
            <div className="flex flex-col md:flex-row w-full h-auto overflow-hidden px-4 md:px-0 py-6">
                <div className="md:w-2/3 w-full py-4 px-2 md:px-6 relative flex flex-col justify-center items-center">
                    <h2 className="text-3xl font-bold text-[#4068AE] mb-6 text-center">
                        {t('appName')}
                    </h2>

                    <div className="w-full h-auto relative">
                        <div ref={sliderRef} className="keen-slider">
                            {services.map((service) => (
                                <div key={service.id} className="keen-slider__slide flex justify-center px-2">
                                    <div
                                        className="rounded-xl text-center w-[250px] h-full flex flex-col justify-start 
                                        transition-transform duration-300 hover:scale-105 
                                        border-4 border-[#4068AE] shadow-md p-4 bg-white min-h-[320px]"
                                    >
                                        <img src={service.image} alt={service.title} className="w-full h-[220px] object-center rounded-md" />
                                        <h3 className="text-lg font-semibold text-[#4068AE] mt-2">{service.title}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <button
                            onClick={() => instanceRef.current?.next()}
                            className={`absolute top-1/2 ${isRTL ? 'right-0' : 'left-0'} w-16 h-16 transform -translate-y-1/2 p-2 z-20 hover:scale-110 transition`}
                        >
                            <img src={isRTL ? right : left} alt="Prev" className="w-full h-full" />
                        </button>
                        <button
                            onClick={() => instanceRef.current?.prev()}
                            className={`absolute top-1/2 ${isRTL ? 'left-0' : 'right-0'} w-16 h-16 transform -translate-y-1/2 p-2 z-20 hover:scale-110 transition`}
                        >
                            <img src={isRTL ? left : right} alt="Next" className="w-full h-full" />
                        </button>
                    </div>

                    <div className="text-3xl md:text-5xl text-[#F8A63A] text-center px-4 py-8 leading-relaxed select-none">
                        <p>{t('msg')}</p>
                        <p className="mt-4">{t('msg2')}</p>
                    </div>
                </div>

                <div className="md:w-1/3 w-full h-[250px] md:h-[500px]">
                    <img
                        src={t('dir') === 'rtl' ? bus : enBus}
                        alt="Bus"
                        className={`w-full h-full object-cover rounded-none ${isRTL ? 'object-right' : 'object-left'}`}
                    />
                </div>
            </div>
        </div>
    );
}
